<template>
  <IModal v-if="shown" v-model="shown" :close-on-click-modal="false" :close-on-press-escape="false" :lock-scroll="true" :with-close-button="false">
    <component :is="activeComponent" />
  </IModal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useUserStore } from '@/js/lib/store/user';
import { PERMISSION_ID_POLICY_UPDATE_202403 } from '@/js/data/permission';
import IModal from '@/js/components/molecules/IModal.vue';
import Policy202403 from './update-policy-202403.vue';

const permissionToComponent = {
  [PERMISSION_ID_POLICY_UPDATE_202403]: Policy202403,
};
const props = defineProps<{
  permissionId: keyof typeof permissionToComponent;
}>();
const userStore = useUserStore();
const { isAgentLogin, isAuthenticated } = userStore;
const activeComponent = computed(() => {
  if (isAgentLogin) {
    return false;
  }

  if (!userStore.hasPermission(props.permissionId)) {
    return permissionToComponent[props.permissionId];
  }

  return false;
});
const shouldNotShowDialog = computed(() => [/^\/news/, /^\/notes/, /^\/privacy/, /^\/rule/].some((pattern) => pattern.test(window.location.pathname)));
const shown = computed(() => isAuthenticated && Boolean(activeComponent.value) && !shouldNotShowDialog.value);
</script>
